import { useState } from 'react'
import icChevronDown from '../../../assets/images/ic-chevron-down.svg'
import icChevronUp from '../../../assets/images/ic-chevron-up.svg'
import { Button, Spinner } from 'avo-ui'
import clsx from 'clsx'

const TabToggle = ({ className, title = 'item', content, isLoading }) => {
    const [show, setShow] = useState(true)

    const setShowContent = () => {
        setShow(!show)
    }

    return (
        <div className={clsx('flex flex-col divide-y divide-blue-100 border border-blue-100 rounded-lg', className)}>
            <div className={'flex items-center justify-between p-4 bg-neutral-5 rounded-lg'}>
                <p className={'text-sm text-blue-90 font-bold capitalize'}>{title}</p>
                <Button
                    type={'outline'}
                    icon={show ? icChevronUp : icChevronDown}
                    className={'!rounded-full'}
                    onClick={setShowContent}
                />
            </div>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <div className={show ? 'block p-4' : 'hidden'}>{content}</div>
            )}
        </div>
    )
}

export default TabToggle
